/*
 * サブシステム名：マスタ管理
 * 機能名：取引先マスタ一覧
 */

import DdTextBox from '@/components/DdTextBox'
import DdRadioButton from '@/components/DdRadioButton'
import DdSubHeader from '@/components/DdSubHeader'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdFooterButton from '@/components/DdFooterButton'
import DdDataTable from '@/components/DdDataTable'
import DdCodeTextBox from '../../components/DdCodeTextBox.vue'
import DdDropDown from '@/components/DdDropDown'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'
import header from '@/ddv2.library/header'

export default {
  name: 'MstTorihikisakiList',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    conditions: {
      torihikisakiCd: '',
      torihikisakiKbn: '0',
      tokuisakiFlg: true,
      shiiresakiFlg: true,
      hacchusakiFlg: true,
      torihikisakiNm: '',
      torihikisakiNmKana: '',
      shanaiTantoshaCd: '',
      torihikisakiBunruiKbn1: '',
      torihikisakiBunruiKbn2: '',
      torihikisakiBunruiKbn3: ''
    },
    headersShanaishuTantoshaList: header.mstJininHeaders,
    modeKengen: 0,
    page: 1
    /*
    headersShanaishuTantoshaList: [
      { width: '60px', text: '社内主担当者コード', value: 'jininCd' },
      { width: '90px', text: '社内主担当者名', value: 'jininNm' }
    ]
    */
  }),
  components: {
    DdSubHeader,
    DdTextBox,
    DdRadioButton,
    DdDefaultButton,
    DdNarrowDownTextBox,
    DdCodeTextBox,
    DdRowCountBox,
    DdFooterButton,
    DdDataTable,
    DdDropDown
  },
  computed: {
    filteredRows () {
      return this.rows.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        elem.hyojiOrderDisp = elem.hyojiOrder ? filter.numericFormatter(elem.hyojiOrder) : ''
        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    isAddButtonDisplay () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    },
    ...mapGetters({
      jininList: 'DDMasters/mstJinin',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      shubetsuList: 'DDMasters/mstShubetsu'
    }),
    filteredShanaishuTantoshaList () {
      const target = filter.dateFormatter(new Date())
      return this.jininList.map((elem) => {
        elem.jininNm = elem.jininNmSei + (elem.jininNmMei ? ' ' + elem.jininNmMei : '')
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.jininCd > elem2.jininCd) { return 1 }
        if (elem1.jininCd === elem2.jininCd) { return 0 }
        return -1
      })
    },
    torihikisakiBunruiKbn1List () {
      const list = this.shubetsuList.filter((elem) => elem.sbtShuruiCd === 'SBT002')
        .map((elem) => {
          elem.value = elem.sbtCd.trim()
          elem.text = elem.sbtNm.trim()
          return elem
        })
      list.unshift({ value: '', text: '' })
      return list
    },
    torihikisakiBunruiKbn2List () {
      const list = this.shubetsuList.filter((elem) => elem.sbtShuruiCd === 'SBT003')
        .map((elem) => {
          elem.value = elem.sbtCd.trim()
          elem.text = elem.sbtNm.trim()
          return elem
        })
      list.unshift({ value: '', text: '' })
      return list
    },
    torihikisakiBunruiKbn3List () {
      const list = this.shubetsuList.filter((elem) => elem.sbtShuruiCd === 'SBT004')
        .map((elem) => {
          elem.value = elem.sbtCd.trim()
          elem.text = elem.sbtNm.trim()
          return elem
        })
      list.unshift({ value: '', text: '' })
      return list
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        conditions: this.conditions,
        searchText: this.searchText,
        rows: this.rows
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msttorihikisaki', 'mstjinin', 'mstshubetsu'],
        defineHeaderPromise: () => {
          return new Promise((resolve) => {
            console.log('MstToriikisakiList.defineHeaderPromise')
            self.headers = [
              { text: '取引先コード', value: 'torihikisakiCd' },
              { text: '得意先', value: 'tokuisaki', align: 'center' },
              { text: '仕入先', value: 'shiiresaki', align: 'center' },
              { text: '発注先', value: 'hacchusaki', align: 'center' },
              { text: '取引先名称', value: 'torihikisakiNm' },
              { text: '取引先名称カナ', value: 'torihikisakiNmKana' },
              { text: '取引先正式名称', value: 'torihikisakiSeishikiNm' },
              { text: '取引先略称', value: 'torihikisakiAbbr' },
              { text: '社内主担当者', value: 'shanaiTantoshaNm' },
              { text: '地域種別', value: 'chiikiKubunNm' },
              { text: '地区種別', value: 'chikuKubunNm' },
              { text: '取引先分類区分１', value: 'torihikisakiBunruiKubun1Nm' },
              { text: '取引先分類区分２', value: 'torihikisakiBunruiKubun2Nm' },
              { text: '取引先分類区分３', value: 'torihikisakiBunruiKubun3Nm' },
              { text: '郵便番号', value: 'yubinNo' },
              { text: '住所１', value: 'jusho1' },
              { text: '住所２', value: 'jusho2' },
              { text: '住所３', value: 'jusho3' },
              { text: '電話番号', value: 'telNo' },
              { text: 'FAX番号', value: 'faxNo' },
              { text: 'メールアドレス', value: 'mailAddress' },
              { text: '部署名', value: 'bushoNm' },
              { text: '取引先担当者名', value: 'tantoshaNm' },
              { text: '適用開始年月日', value: 'tekiyoStartYmdDisp', align: 'center' },
              { text: '適用終了年月日', value: 'tekiyoEndYmdDisp', align: 'center' },
              { text: '表示順', value: 'hyojiOrderDisp', align: 'end' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            console.log('initializeInputPromise')
            self.conditions = {
              torihikisakiCd: '',
              torihikisakiKbn: '0',
              tokuisakiFlg: false,
              shiiresakiFlg: false,
              hacchusakiFlg: false,
              torihikisakiNm: '',
              torihikisakiNmKana: '',
              shanaiTantoshaCd: '',
              torihikisakiBunruiKbn1: '',
              torihikisakiBunruiKbn2: '',
              torihikisakiBunruiKbn3: ''
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('MstTorihikisakiList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('MstTorihikisakiList.savedInputRestorePromise after loadFromCache', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('MstTorihikisakiList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.onSearchButtonClick()
            resolve()
            // self.search().then(() => {
            //   resolve()
            // })
          })
        },
        restoreViewPromise: (c) => {
          console.log('MstTorihikisakiList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          self.setSelectedKbn()
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCMstTorihikisaki/Search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
            torihikisakiKbn: self.conditions.torihikisakiKbn
          }
        }
      }
      this.search(opt)
    },
    /*
    onSearchButtonClick: function (e) {
      const isValid = this.validateAll(this.$refs)
      console.log('validate all', isValid)
      if (isValid) {
        this.Effects.loadStart()
        console.log('コンディション')
        console.log(this.conditions)
        this.search().then(() => {
          console.log('this.search()', this.rows)
          this.Effects.loadComplete()
        })
      }
    },
    search: function () {
      this.setSelectedKbn()
      return new Promise(resolve => {
        this.HttpClient
          .post('/api/v1/VwCMstTorihikisaki/Search', this.conditions)
          .then((data) => {
            console.log(data.payload)
            this.rows = data.payload

            const cache = {
              rows: this.rows,
              conditions: this.conditions,
              searchText: this.searchText
            }

            this.saveToChache(cache)
              .then(() => {
                resolve()
              })
          })
      })
    },
    */
    setSelectedKbn: function () {
      const kbn = this.conditions.torihikisakiKbn
      this.conditions.tokuisakiFlg = kbn === '1'
      this.conditions.shiiresakiFlg = kbn === '2'
      this.conditions.hacchusakiFlg = kbn === '3'
    },
    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      console.log('clear pushed')
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            self.conditions = {
              torihikisakiCd: '',
              torihikisakiKbn: '0',
              tokuisakiFlg: false,
              shiiresakiFlg: false,
              hacchusakiFlg: false,
              torihikisakiNm: '',
              torihikisakiNmKana: '',
              shanaiTantoshaCd: '',
              torihikisakiBunruiKbn1: '',
              torihikisakiBunruiKbn2: '',
              torihikisakiBunruiKbn3: ''
            }
            self.searchText = ''
            self.rows = []
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onRowClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      console.log('編集画面呼び出し開始')
      this.transition(0, { id: e.id })
    },
    onCsvButtonClick: function (e) {
      this.HttpClient.post('/api/v1/VwCMstTorihikisaki/download', this.conditions).then((data) => {
        const bom = new Uint8Array([0xef, 0xbb, 0xbf])
        const blob = new Blob([bom, data], { type: 'text/csv' })
        const elem = document.getElementById('download')
        elem.href = window.URL.createObjectURL(blob)
        // elem.download = '取引先マスタ一覧_' + this.getFormatDate(new Date()) + '.csv'
        elem.click()
      })
    },
    getFormatDate: function (date) {
      const formatDate = new Date(date)
      const Y = formatDate.getFullYear()
      const M = ('00' + (formatDate.getMonth() + 1)).slice(-2)
      const D = ('00' + formatDate.getDate()).slice(-2)
      const h = ('00' + formatDate.getHours()).slice(-2)
      const m = ('00' + formatDate.getMinutes()).slice(-2)
      const s = ('00' + formatDate.getSeconds()).slice(-2)
      return Y + M + D + '_' + h + m + s
    },
    onCreateButtonClick: function (e) {
      console.log('onCreateButtonClick 0', e)
      this.Effects.loadStart()
      this.transition(0, { id: 0 })
    },
    onTokuisakiCreateButtonClick: function (e) {
      console.log('onCreateButtonClick 1', e)
      this.Effects.loadStart()
      this.transition(1, { id: 0 })
    },
    onHacchusakiCreateButtonClick: function (e) {
      console.log('onCreateButtonClick 2 ', e)
      this.Effects.loadStart()
      this.transition(2, { id: 0 })
    },
    onShiiresakiCreateButtonClick: function (e) {
      console.log('onCreateButtonClick 3', e)
      this.Effects.loadStart()
      this.transition(3, { id: 0 })
    },
    searchValidate: function () {
      return true
    }
  }
}
